import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box } from '@mui/material';
import {motion} from 'framer-motion';
import {withTranslation, WithTranslation} from "react-i18next";

interface SkillsProps extends WithTranslation {}

class Skills extends React.Component<SkillsProps> {
    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    render(): JSX.Element {
        const { t } = this.props;
        const skills = [
            { name: 'React', icon: <i className="devicon-react-original colored"></i> },
            { name: 'PHP', icon: <i className="devicon-php-plain colored"></i>},
            { name: 'Symfony', icon: <i className="devicon-symfony-original colored"></i> },
            { name: 'Laravel', icon: <i className="devicon-laravel-plain colored"></i> },
            { name: 'TypeScript', icon: <i className="devicon-typescript-plain colored"></i> },
            { name: 'Angular', icon: <i className="devicon-angularjs-plain colored"></i> },
            { name: 'Python', icon: <i className="devicon-python-plain colored"></i> },
            { name: 'C#', icon: <i className="devicon-csharp-plain colored"></i> },
            { name: 'C++', icon: <i className="devicon-cplusplus-plain colored"></i> },
        ];

        return (
            <Container style={{ padding: '40px 0', textAlign: 'center' }} id="skills">
                <Typography variant="h3" gutterBottom style={{ fontWeight: 'bold', color: '#0A74DA' }}>
                    {t('skills')}
                </Typography>
                <Grid container spacing={3}>
                    {skills.map((skill, index: number) => (
                        <Grid item xs={12} sm={6} md={4} key={skill.name}>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                            >
                                <Card sx={{
                                    backgroundColor: "seconary",
                                    ':hover': {
                                        boxShadow: '0px 4px 20px black',
                                    },
                                }}>
                                    <CardContent>
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '150px',
                                        }}>
                                            <motion.div
                                                whileHover={{ scale: 1.2 }}
                                                whileTap={{ scale: 0.8 }}
                                            >
                                                {skill.icon}
                                            </motion.div>
                                            <Typography variant="h5" component="h2" style={{ fontWeight: 'bold', marginLeft: '10px' }}>
                                                {skill.name}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        );
    }
}

export default withTranslation()(Skills);
